import React from 'react';
import {getZIndex} from "../../Utility/html";

//
// Empty divs but with CSS that makes it look like parallel throbbing lines.
// Styled in global/_page_components.scss, with animation in _spinner.scss
//
export default function PulsingLinesThrobber() {
  const zIndex = getZIndex('pulsingLinesThrobber');

  // FIXME opacity-75
  return <div className="fixed inset-0" style={{zIndex}}>
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-white opacity-75"
      style={{zIndex: zIndex + 1}}></div>

    <div className="bg-gray-100 centered p-12 rounded-xl" style={{zIndex: zIndex + 2}}>
      <div className="la-line-scale-pulse-out la-2x">
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
      </div>
    </div>
  </div>;
}
